import { DivisibleReceiver } from './DivisibleReceiver';
import type DynamicTarget from './DivisibleTarget';

declare module './DivisibleReceiver' {
    interface DivisibleReceiver {
        purgeSubscriptions(): this;
        purgeSubscriptions(key: string, ...otherKeys: string[]): this;
        unsubscribe(): this;
        unsubscribe(key: string, ...otherKeys: string[]): this;
        complete(): this;
        complete(key: string, ...otherKeys: string[]): this;
        close(): this;
        close(key: string, ...otherKeys: string[]): this;
    }
}

for (const k of [
    'purgeSubscriptions',
    'unsubscribe',
    'complete',
    'close',
] as Array<keyof DynamicTarget>)
    DivisibleReceiver.prototype[k] = DivisibleReceiver.allOrKeysMethod(k);
